<template>
  <v-container>
    <v-dialog v-model="show_dialog_box" max-width="500px">
      <template v-slot:activator="{ on }">
        <v-btn text v-on="on" class="font-weight-bold text-capitalize" color="primary">
          Day Choice
        </v-btn>
      </template>
      <v-card color="pop_bg">
        <v-card-title>
          <span class="text-h6 dark--text">Day Choices</span>
          <v-spacer></v-spacer>
          <v-btn text color="dark" @click="show_dialog_box = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text v-if="data">
          <div v-for="item in data" :key="item._id">
            <v-divider class="mt-4"></v-divider>
            <v-row class="mt-6">
              <strong>
                {{ item.day }}
              </strong>
            </v-row>

            <div v-for="choice in item.mealCount" :key="choice.menuCategoryId">
              <v-row class="mt-4" v-if="choice.menuCategoryId"> {{ getCategoryName(choice.menuCategoryId) }} :{{ choice.count }} </v-row>
              <v-row class="mt-4" v-else> {{ choice.category.nameEn }} :{{ choice.count }} </v-row>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  apollo: {
    getAllCategories() {
      return {
        query: require("@/menu-packages/api/getAllCategories.graphql"),
        variables: {
          limit: 0,
          skip: 0,
        },
        result({ data, loading }) {
          this.loading = loading;
          this.allCategories = data.getAllCategories.category;
        },
      };
    },
  },
  components: {},
  methods: {
    getCategoryName(id) {
      if (this.allCategories) {
        let category = this.allCategories.find(x => x._id == id);
        return category.nameEn;
      }
      return "";
    },
  },
  props: {
    dayChoices: {
      require: true,
    },
  },
  created() {
    this.data = JSON.parse(JSON.stringify(this.dayChoices));
  },
  watch: {
    dayChoices: {
      handler(newVal) {
        this.data = JSON.parse(JSON.stringify(newVal));
        debugger;
      },
      deep: true,
    },
  },

  data: () => ({
    loading: true,
    show_dialog_box: false,
    allCategories: [],
  }),
};
</script>
